import { Button, Paper } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';

import { GuardedComponent } from "../../../components/guarded-component";
import { SiTrackPage } from "../../../components/si-track-page";
import { UserPermissionName } from "../../../models/user-permission-name";
import { ProjectSubtype } from "../../../models/masters/project-subtype";
import { useState } from "react";
import { SiTrackGrid } from "../../../components/si-track-grid/si-track-grid";
import { columns } from "./grid-columns";
import { projectSubTypeApiKeyStore } from "../../../api/masters/project-subtype-api-key-store";
import { SaveHookFormDialog } from "../../../components/save-hook-form.dialog";
import { projectSubtypeFormSchema } from "./project-subtype-form.schema";
import { ProjectSubtypeForm } from "./project-subtype.form";

const styling = {
    paperStyle: { padding: '20px', borderRadius: '20px' },
};

export const ProjectSubtypePage = () => {
    const [editItem, setEditItem] = useState<Partial<ProjectSubtype>>();

    const handleEditProjectSubtype = (projectSubtype: ProjectSubtype) => {
        setEditItem(projectSubtype);
    };

    const handleEditClose = () => {
        setEditItem(undefined);
    };

    const handleCreateProjectSubtype = () => {
        setEditItem({});
    };

    return (
        <SiTrackPage
            title="Project Subtype"
            actionButton={
                <GuardedComponent requiredPermissions={[UserPermissionName.ADD_PROJECTSUBTYPE]}>
                    <Button
                        size="small"
                        variant="contained"
                        disableElevation={true}
                        startIcon={<AddIcon />}
                        onClick={handleCreateProjectSubtype}
                    >
                        Add Project Subtype
                    </Button>
                </GuardedComponent>
            }
        >
            <Paper elevation={0} style={styling.paperStyle}>
                <SiTrackGrid
                    fileTitle='project_subtype'
                    dataItemKey="projectSubTypeID"
                    columns={columns}
                    queryConfig={projectSubTypeApiKeyStore.getProjectSubTypes()}
                    onEdit={handleEditProjectSubtype}
                    deleteMutationConfig={(deleteItem) => projectSubTypeApiKeyStore.deleteProjectSubType(deleteItem.projectSubTypeID)}
                    actionPermissions={{
                        edit: UserPermissionName.EDIT_PROJECTSUBTYPE,
                        delete: UserPermissionName.DELETE_PROJECTSUBTYPE,
                        export: UserPermissionName.DOWNLOAD_GRID
                    }}
                />
                {editItem && (
                    <SaveHookFormDialog
                        title={editItem.projectSubTypeID ? 'UPDATE PROJECT SUBTYPE' : 'CREATE PROJECT SUBTYPE'}
                        config={{
                            saveConfig: editItem.projectSubTypeID
                                ? projectSubTypeApiKeyStore.updateProjectSubType()
                                : projectSubTypeApiKeyStore.createProjectSubType(),
                            invalidateRoute: () => projectSubTypeApiKeyStore.getProjectSubTypes(),
                        }}
                        data={editItem}
                        yupSchema={projectSubtypeFormSchema}
                        onClose={handleEditClose}
                        size="xs"
                    >
                        <ProjectSubtypeForm />
                    </SaveHookFormDialog>
                )}
            </Paper>
        </SiTrackPage>
    );
}